<template>
    <div>

<!--                        <b-table-->
<!--                                :data="isEmpty ? [] : dataEach "-->
<!--                                mobile-cards-->
<!--                                paginated-->
<!--                                :current-page.sync="currentPage"-->
<!--                                :per-page="perPage"-->
<!--                        >-->
        <b-dropdown
                v-model="datWantToSeeModel"
                multiple
                aria-role="list"
        >
            <button class="button  is-success" type="button" slot="trigger" >
                <span>Filter to ({{ datWantToSeeModel.length }})</span>
                <b-icon icon="menu-down"></b-icon>
            </button  >

            <b-dropdown-item v-for="datPathoUniq in datPathoUniqs" :value="datPathoUniq" :key="datPathoUniq" aria-role="listitem">
                <span>{{datPathoUniq}}</span>
            </b-dropdown-item>

        </b-dropdown>






                            <b-table
                                    :data="isEmpty ? [] : dataEachFilter "
                                    mobile-cards
                            >
                            <b-table-column  label="No." centered v-slot="props">
                                <p class="is-size-6">{{ props.row.id }}</p>
                            </b-table-column>

                            <b-table-column  label="LAB No." centered v-slot="props">
                                <p class="is-size-6">{{ props.row.idlab }}</p>
                            </b-table-column>


                            <b-table-column  label="OPD No." centered v-slot="props">
                                <p class="is-size-6">{{ props.row.opd_no }}</p>
                            </b-table-column>

                            <b-table-column  label="OPD Name" centered v-slot="props">
                                <p class="is-size-6">{{ props.row.opd_name }}</p>
                            </b-table-column>

                            <b-table-column  label="Owner" centered v-slot="props">
                                <p class="is-size-6">{{ props.row.owner_name }}</p>
                            </b-table-column>


                            <b-table-column  label="DateTime to Order" centered v-slot="props">
                                <p class="is-size-6">{{ props.row.order_date }}  {{ props.row.order_time }}  </p>
                            </b-table-column>


                            <b-table-column  label="Order By" centered v-slot="props">
                                <p class="is-size-6"> {{props.row.order_by}} </p>
                            </b-table-column>


                            <b-table-column  label="Order No." centered v-slot="props">
                                <p class="is-size-6"> {{props.row.idorder }} </p>
                            </b-table-column>


                            <b-table-column  label="DVM" centered v-slot="props">
                                <p class="is-size-6"> {{props.row.dvm }} </p>
                            </b-table-column>

                            <b-table-column  label="Department" centered v-slot="props">
                                <p class="is-size-6"> {{props.row.department }} </p>
                            </b-table-column>

                            <b-table-column  label="Assigned to" centered v-slot="props">
                                <p class="is-size-6"> {{props.row.assigned_to }} </p>
                            </b-table-column>

                            <b-table-column  label="DateTime to Assigned " centered v-slot="props">
                                <p class="is-size-6"> {{props.row.assign_date }}  {{props.row.assign_time }} </p>
<!--                                 <span class="tag is-success">-->
                                    {{getMonthWeekdayAbbreviation(props.row.weekday)}}
<!--                                 </span>-->

                            </b-table-column>

                            <b-table-column  label="Assigned By" centered v-slot="props">
                                <p class="is-size-6"> {{props.row.assign_by }} </p>
                            </b-table-column>

                            <b-table-column  label="Diff. Date(LAB No.)" centered v-slot="props">
                                <p class="is-size-6"> {{props.row.diff_date_lab }} </p>
                            </b-table-column>

                            <b-table-column  label="Diff. Date(ORDER No.)" centered v-slot="props">
                                <p class="is-size-6"> {{props.row.diff_date_order }} </p>
                            </b-table-column>

                            <b-table-column  label="Status" centered v-slot="props">
                                <p class="is-size-6"> {{props.row.status }} </p>
                            </b-table-column>

                            <template slot="empty">
                                <section class="section">
                                    <div class="content has-text-grey has-text-centered">
                                        <p>
                                            <b-icon
                                                    icon="emoticon-sad"
                                                    size="is-large">
                                            </b-icon>
                                        </p>
                                        <p>Nothing here.</p>
                                    </div>
                                </section>
                            </template>
                        </b-table>
    </div>
</template>

<script>

    import {month_weekday_abbreviation} from  '@/utils.js'
    export default {
        name: "WarningLabUnPublish_Data",
        props:{
            name:String,
            dataEach : Array
        },
        computed:{

            dataEachFilter: function(){
                return this.dataEach.filter(dat=>{
                    if( this.datWantToSee.indexOf(dat.assigned_to)>-1){
                        return dat
                    }
                })
            },
            datWantToSeeModel : {
                get: function () {
                    return this.datWantToSee
                },
                set: function (newValue) {
                    this.datWantToSee = newValue
                }
            }
        },
        methods:{
            getMonthWeekdayAbbreviation(_id){
                return month_weekday_abbreviation[_id]
            },
        },
        data(){
            return {
                isEmpty : false,
                currentPage : 1 ,
                perPage : 50,

                datPathoUniqs : [],
                datWantToSee : []
            }
        },
        watch:{
            dataEach: {
                immediate: true,
                handler : function (val) {
                    this.datPathoUniqs = []
                    this.datWantToSee = []
                    val.map(dat=>{
                        if (this.datPathoUniqs.indexOf(dat.assigned_to) === -1){
                            this.datPathoUniqs.push(dat.assigned_to)
                            this.datWantToSee.push(dat.assigned_to)
                        }
                    })
                }

            }
        }
    }
</script>

<style scoped>

</style>